<app-learning-hub-header
  [lang]="lang"
  [options]="languageOptions"
  (selectLanguage)="changeLanguage($event)"
></app-learning-hub-header>

<div class="lh-columns">
  <div class="lh-main">
    <app-learning-hub-breadcrumb [items]="breadcrumb" [lang]="lang"></app-learning-hub-breadcrumb>
    <h1 class="lh-search-title">{{ 'learningHub.searchTitle' | lhTranslate: lang }}</h1>

    <app-learning-hub-search-box
      class="lh-search-field"
      [lang]="lang"
      [query]="query"
      [live]="true"
      (queryChange)="search($event)"
    ></app-learning-hub-search-box>

    <div class="lh-active-tag" *ngIf="selectedTag">
      <span class="lh-chip lh-chip--active">#{{ selectedTag.name }}</span>
      <button type="button" class="lh-link-button" (click)="clearTag()">
        {{ 'learningHub.clearTag' | lhTranslate: lang }}
      </button>
    </div>

    <p class="lh-status" *ngIf="loading">{{ 'learningHub.loading' | lhTranslate: lang }}</p>
    <p class="lh-state" *ngIf="!loading && error">{{ 'learningHub.loadError' | lhTranslate: lang }}</p>

    <ng-container *ngIf="!loading && !error">
      <p class="lh-count" aria-live="polite">{{ 'learningHub.results' | lhTranslate: lang:{ count: results.length } }}</p>

      <div class="lh-state" *ngIf="!results.length">
        <p>{{ 'learningHub.noResults' | lhTranslate: lang }}</p>
        <button type="button" class="lh-state-button" (click)="clearFilters()">
          {{ 'learningHub.clearFilters' | lhTranslate: lang }}
        </button>
      </div>

      <app-learning-hub-article-rows
        *ngIf="results.length"
        [articles]="results"
        [showSummary]="true"
      ></app-learning-hub-article-rows>
    </ng-container>
  </div>

  <app-learning-hub-sidebar
    class="lh-aside"
    *ngIf="tree"
    [lang]="lang"
    [tree]="tree"
    [articles]="articles"
  ></app-learning-hub-sidebar>
</div>
